// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3Oyqs","emails":"CreateEditClinics_emails__9hO2T","emailTagLabel":"CreateEditClinics_emailTagLabel__2w0ai"};